<script setup lang="ts">
import { computed } from 'vue'

type SearchUser = {
  image?: string
  name: string
  languages?: string[]
}

const props = withDefaults(
  defineProps<{
    user: SearchUser
    highlightText?: string
  }>(),
  {
    highlightText: ''
  }
)

const userName = computed(() => {
  return props.user.name.replace(props.highlightText, match => `<span class="blue-text">${match}</span>`)
})
</script>

<template>
  <div class="user-search-block">
    <v-img
      v-if="user.image"
      class="user-search-block__image"
      resize
      width="64"
      height="64"
      :src="user.image"
      :alt="user.name"
    ></v-img>
    <div class="user-search-block__content">
      <strong class="user-search-block__name text-body-bold" v-html="userName"></strong>
      <p v-if="user.languages" class="user-search-block__languages mt-1">
        {{ user.languages.join(', ') }}
      </p>
    </div>
  </div>
</template>

<style lang="scss">
.user-search-block {
  display: flex;
  align-items: flex-start;

  @include text-caption;

  &__image {
    width: 8 * $grid-gap;
    height: 8 * $grid-gap;
    min-width: 8 * $grid-gap;
    min-height: 8 * $grid-gap;
    border-radius: 50%;
    margin-right: 2 * $grid-gap;
  }

  &__content {
    display: flex;
    flex-direction: column;
  }
}
</style>
